// removed by extract-text-webpack-plugin
module.exports = {"itemLink":"RecentlyViewedItemsCarousel__itemLink__195695c9","image":"RecentlyViewedItemsCarousel__image__195695c9"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/RecentlyViewedItems/RecentlyViewedItemsCarousel.scss
// module id = 1813
// module chunks = 7 21